import React, {PropTypes} from "react";
import axios from "axios";
import ModalExitView from "./ModalExitView";

class MyExitHome extends React.Component {

  constructor() {
    super();
    this.state = {employee: null};

  }

  componentDidMount() {
    this.props.changeBanner("My Exit");
    axios.get(process.env.REQ_URL + "/getExitById?q=" + this.props.employee.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {


      this.setState({employee: response.data.data, showExit: true})

    }).catch((error) => {
      console.log(error);
    });

  }

  render() {
    return (<div>
        <div className="col-md-3"></div>
        <div className="col-md-6">

          <h2 style={{paddingLeft: '35%'}}><u>Employee Exit</u></h2>
          <br/>
          {this.state.employee != null ? <ModalExitView employee={this.state.employee}/> : null}</div>

        <div className="col-md-3"></div>
      </div>
    );
  }
}

MyExitHome.propTypes = {};

export default MyExitHome;





/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/MyExit/MyExitHome.js
 **/